import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import App from './App.jsx';
import './index.css'

export const API = process.env && process.env.REACT_APP_API_URL && typeof process.env.REACT_APP_API_URL === 'string'
    ? process.env.REACT_APP_API_URL
    : 'https://ca.reportsapi.fairviewfittings.com/';

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./app/web/src/index.js